export default __webpack_public_path__ + "static/screenshot_1-4ec64c800b76df37145e1de36167de91.png";